/** @format */

import React from 'react';
import { makeStyles } from '@material-ui/core';
import getRedirectionLink from '../../../utils/helper';
import { Link } from 'react-router-dom';
import useStyles from 'src/components/Loader/styles';
import { Tooltip } from 'src/components/tooltip';

const InfoWidget = props => {
  const { image, w, h, title, linkTarget, linkTitle, tooltip, link } = props.data;
  let fullImage = process.env.REACT_APP_API_URL + image;
  return (
    <div className={`info-widget ${useStyles().card}`} data-width={w} data-height={h}>
      <img src={fullImage} alt="card-icon" className={useStyles().icon} />
      <div className="card-title-outer">
        <h2 className={`card-title ${useStyles().title}`}>{title}</h2>
      </div>
      {link ? (
        <a href={getRedirectionLink(props.data)} target={`${linkTarget === '_blank' ? '_blank' : ''}`}>
          <p className="card-text">{linkTitle}</p>
        </a>
      ) : (
        <Link to={getRedirectionLink(props.data)}>
          <p className="card-text">{linkTitle}</p>
        </Link>
      )}
      {tooltip && (
        <div className="info-widget--list-item-tooltip">
          <Tooltip content={tooltip} placement="bottom" />
        </div>
      )}
    </div>
  );
};

export { InfoWidget };
